import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileCTA from '@/components/MobileCTA';
import EnhancedQuoteCalculator from '@/components/EnhancedQuoteCalculator';
import SEO from '@/components/SEO';

const QuotePage = () => {
  const { language } = useLanguage();

  const breadcrumbs = [
    { name: language === 'en' ? 'Home' : 'Inicio', url: `/${language}` },
    { name: language === 'en' ? 'Quote' : 'Cotización', url: language === 'en' ? '/en/quote' : '/es/cotizacion' }
  ];

  const seoTitle = language === 'en' 
    ? 'Free Material Calculator & Quote Texas | Landscaping Cost Estimator'
    : 'Calculadora de Materiales y Cotización Gratis Texas | Estimador de Costos de Paisajismo';
  
  const seoDescription = language === 'en'
    ? 'Get instant free quote for landscaping materials in Montgomery County TX. Calculate costs for sod, soil, rock, mulch, sand with delivery. Professional service.'
    : 'Obtenga cotización instantánea gratis para materiales de paisajismo en el Condado Montgomery TX. Calcule costos para césped, tierra, roca, mulch, arena con entrega. Servicio profesional.';
  
  const seoKeywords = language === 'en'
    ? 'free quote calculator texas, landscaping materials quote, sod delivery quote montgomery county, bulk materials pricing texas'
    : 'calculadora cotización gratis texas, cotización materiales paisajismo, cotización entrega césped montgomery county, precios materiales granel texas';

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": seoTitle,
    "description": seoDescription,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Any",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free Quote Calculator"
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        canonical={language === 'en' ? '/en/quote' : '/es/cotizar'}
        structuredData={structuredData}
        language={language}
        breadcrumbs={breadcrumbs}
      />
      <Header />
      
      <main>
      {/* Hero Section */}
      <section className="py-16 bg-gradient-natural text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6">
            {language === 'en' ? 'Material Calculator & Quote' : 'Calculadora de Materiales y Cotización'}
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            {language === 'en'
              ? 'Calculate quantities and costs for your landscaping materials. Get instant pricing for grass, rock, mulch, soil, sand with delivery included.'
              : 'Calcule cantidades y costos para sus materiales de paisajismo. Obtenga precios instantáneos para pasto, roca, mulch, tierra, arena con entrega incluida.'
            }
          </p>
        </div>
      </section>

      <EnhancedQuoteCalculator />
      </main>
      
      <Footer />
      <MobileCTA />
    </div>
  );
};

export default QuotePage;